import { atom } from "recoil";
import { ResponseGetWarehouseResponse } from "../../services/OpenAPI";

export const warehousesState = atom<ResponseGetWarehouseResponse[] | null>({
  key: "warehousesState",
  default: null,
});
